"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Label: function() {
        return _index.Label;
    },
    labelClassNames: function() {
        return _index.labelClassNames;
    },
    renderLabel_unstable: function() {
        return _index.renderLabel_unstable;
    },
    useLabelStyles_unstable: function() {
        return _index.useLabelStyles_unstable;
    },
    useLabel_unstable: function() {
        return _index.useLabel_unstable;
    }
});
const _index = require("./components/Label/index");
